import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Clock, MapPin } from 'lucide-react';
import { calendario as calendarioMock } from '../data/mock';
import { api } from '../api/client';

export default function ProgrammaSection() {
  const [calendario, setCalendario] = useState(calendarioMock);
  useEffect(() => {
    let alive = true;
    api.getCalendarioFull().then((rows) => {
      if (!alive) return;
      if (Array.isArray(rows) && rows.length > 0) {
        setCalendario(rows.map((r) => ({ giorno: r.giorno || '', data: r.data || '', eventi: r.eventi || [] })));
      }
    }).catch(() => { /* fallback su mock */ });
    return () => { alive = false; };
  }, []);

  const preview = calendario.slice(0, 3);

  return (
    <section className="py-20 bg-navy">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <h2 className="section-title text-4xl md:text-5xl">Programma</h2>
            <p className="text-white/70 mt-6 max-w-xl">
              Il programma del torneo dal 25 al 31 maggio 2026
            </p>
          </div>
          <Link to="/calendario" className="btn-primary self-start lg:self-auto">
            <Calendar size={18} /> Calendario Completo
            <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {preview.map((day, i) => (
            <div key={i} className="glass-card overflow-hidden">
              <div className="bg-pink-brand px-5 py-3 flex items-center justify-between">
                <div className="text-white">
                  <div className="text-xs font-semibold uppercase opacity-80">{day.giorno}</div>
                  <div className="font-bold text-base leading-tight">{day.data.replace(day.giorno, '').trim()}</div>
                </div>
                <Calendar size={22} className="text-white" />
              </div>
              <div className="p-5 space-y-3">
                {day.eventi.slice(0, 3).map((e, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <div className="flex items-center gap-1 bg-navy-light px-2 py-1 rounded text-[11px] font-bold text-white flex-shrink-0 min-w-[60px] justify-center">
                      <Clock size={10} /> {e.ora}
                    </div>
                    <div className="min-w-0">
                      <div className="text-white text-sm font-semibold leading-snug">{e.evento}</div>
                      <div className="flex items-center gap-1 text-white/60 text-xs mt-0.5">
                        <MapPin size={10} /> {e.luogo}
                      </div>
                    </div>
                  </div>
                ))}
                {day.eventi.length > 3 && (
                  <div className="text-pink-brand text-xs font-bold text-center pt-2 border-t border-white/10">
                    + {day.eventi.length - 3} altri eventi
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
